import { meetingFormData } from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllMeetings = (
  page: number,
  startAt: string,
  endAt: string
): Promise<unknown> => {
  return get(`${BASE_URL}/meetings?startAt=${startAt}&endAt=${endAt}`)
}

export const getMeetingById = (id: string): Promise<unknown> => {
  return get(`${BASE_URL}/meetings/${id}`)
}

export const createMeeting = (data: meetingFormData): Promise<unknown> => {
  return post(`${BASE_URL}/meetings`, data, null)
}

export const updateMeeting = (
  data: meetingFormData,
  id: string
): Promise<unknown> => {
  return patch(`${BASE_URL}/meetings/${id}`, data, null)
}

export const deleteMeeting = ({
  id,
}: {
  id: string | undefined
}): Promise<unknown> => {
  return del(`${BASE_URL}/meetings/${id}`, null)
}
